<template>
  <form @submit.prevent="save">
    <b-message type="is-danger" v-if="errors.length > 0">
      <p v-for="error in errors">{{error}}</p>
    </b-message>
    <div class="columns is-multiline">
      <div class="column is-2">
          <b-field>
              <form-datepicker :label="$t('employees.birthday')" v-model="form.birthday"></form-datepicker>
          </b-field>
      </div>
        <div class="column is-3">
            <b-field>
                <form-input :label="$t('employees.mobilePhone')" v-model="form.mobile_phone"></form-input>
            </b-field>
        </div>
        <div class="column is-3">
            <b-field>
                <form-input :label="$t('employees.workPhone')" v-model="form.work_phone"></form-input>
            </b-field>
        </div>
        <div class="column is-2">
            <b-field>
                <form-input :label="$t('employees.workplace')" v-model="form.workplace_office"></form-input>
            </b-field>
        </div>
        <div class="column is-1">
            <b-field>
                <form-input :label="$t('employees.level')" v-model="form.workplace_level"></form-input>
            </b-field>
        </div>
        <div class="column is-1">
            <b-field>
                <form-input :label="$t('employees.cabinet')" v-model="form.workplace_cabinet_number"></form-input>
            </b-field>
        </div>
        <div class="column is-6">
            <b-field>
                <form-textarea :label="$t('employees.about')" v-model="form.bio"></form-textarea>
            </b-field>
        </div>
      <div class="column is-8">
        <b-field class="file">
          <b-upload v-model="form.photo">
            <a class="button is-warning">
              <span>{{ $t('employees.profilePhoto') }}</span>
            </a>
          </b-upload>
          <span class="file-name">
            <template v-if="form.photo">{{ form.photo.name }}</template>
            <template v-else>{{ $t('interface.noFileSelected') }}</template>
          </span>
        </b-field>
      </div>
      <div class="column is-12">
          <h3 class="title is-5 mt-10">{{ $t('employees.interfaceSetups') }}</h3>
      </div>
        <div class="column is-2">
            <b-field>
                <form-select :label="$t('employees.language')" v-model="form.locale">
                    <option value="ru">Русский</option>
                    <option value="uz">O`zbekcha</option>
                </form-select>
            </b-field>
        </div>
        <div class="column is-10">
            <div class="mt-20">
                <b-switch v-model="form.telegram_notifications" class="mr-20">{{ $t('employees.telegramNotifications')
                    }}
                </b-switch>
                <b-switch v-model="form.document_preview">{{ $t('employees.documentPreview') }}</b-switch>
            </div>
        </div>
        <div class="column is-6">
            <h4 class="title is-6 mb-10 mt-10">{{ $t('employees.telegramSessions') }}</h4>
            <b-table :data="form.telegram_chats" class="maintainers-table">
                <template slot-scope="props">
                    <b-table-column :label="$t('employees.username')" field="name" sortable>
                        {{ props.row.username }}
                    </b-table-column>
                    <b-table-column :label="$t('employees.chatNumber')" field="is_read" width="160" sortable>
                        {{ props.row.chat_id }}
                    </b-table-column>
                    <b-table-column :label="$t('employees.actions')" width="120">
              <a @click.prevent="removeSession(props.row.id)">
                <b-icon icon="trash-can-outline" size="is-small"></b-icon>
                {{ $t('interface.remove') }}
              </a>
            </b-table-column>
          </template>
          <template slot="empty">
            <section class="section">
              <div class="content is-fluid has-text-grey has-text-centered">
                <p>
                  <span class="has-text-grey-light">{{ $t('employees.noActiveSessions') }}</span>
                </p>
              </div>
            </section>
          </template>
        </b-table>
      </div>
      <div class="column is-12">
        <div class="field is-grouped mt-10">
          <div class="control">
            <button type="submit" class="button is-primary">{{ $t('interface.save') }}</button>
          </div>
          <div class="control">
            <button class="button is-danger" @click.prevent="cancel">{{ $t('interface.cancel') }}</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import CounterpartSelect from '@/components/CounterpartSelect'
  import {prepareDate} from '@/utils'

  const defaultEmployeeData = {
    birthday: null,
    mobile_phone: null,
    work_phone: null,
    workplace_office: null,
    workplace_level: null,
    workplace_cabinet_number: null,
    bio: null,
    photo: null,
    locale: 'ru',
    telegram_notifications: true,
    document_preview: false
  }

  export default {
    props: ['employeeData'],
    components: {CounterpartSelect},
    data() {
      return {
        form: this.employeeData || {...defaultEmployeeData},
        isEdit: this.employeeData,
        errors: []
      }
    },
    methods: {
      validate() {
        this.errors = []
        return this.errors.length === 0
      },
      save() {
        if (this.validate()) {
          this.$emit('save', {
            ...this.form,
            birthday: this.form.birthday ? prepareDate(this.form.birthday) : null
          })
        }
      },
      removeSession(id) {
        this.$store.dispatch('Employees/removeTelegramSession', id)
      },
      cancel() {
        this.$router.go(-1)
      }
    },
    watch: {
      employeeData(data) {
        this.form = data
      }
    }
  }
</script>
